export const Marquee = () => {
  const items = [
    "Mass Save HPIN Partner",
    "Family-Owned",
    "Excellence",
    "Integrity",
    "Clean Workmanship",
    "Treated Like Family",
  ];
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-border bg-sand py-6" data-testid="editorial-marquee">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 text-2xl md:text-3xl font-serif text-navy">
            {t}
            <span className="text-gold text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
